import { useEffect } from "react";
import { app, authentication } from "@microsoft/teams-js";
import { ENV } from "../env";

/** Popup page that starts a fresh Entra sign-in for the step-up (`prompt=login`, `max_age=0`, BR-175). */
export function AuthStart() {
  useEffect(() => {
    void (async () => {
      await app.initialize();
      // a Microsoft page to open in the popup (admin consent): only Microsoft's sign-in host, never an arbitrary address
      const next = new URLSearchParams(window.location.search).get("next");
      if (next) {
        let target: URL | undefined;
        try {
          target = new URL(next);
        } catch {
          /* not a URL */
        }
        if (target?.protocol === "https:" && target.hostname === "login.microsoftonline.com") {
          window.location.assign(target.href);
        } else authentication.notifyFailure("invalid_start_url");
        return;
      }
      const redirect = `${window.location.origin}/auth-end`;
      const params = new URLSearchParams({
        client_id: ENV.aadClientId,
        response_type: "token",
        redirect_uri: redirect,
        scope: ENV.apiScope,
        prompt: "login",
        max_age: "0",
        response_mode: "fragment",
      });
      window.location.assign(`${ENV.aadTenantAuthority}/oauth2/v2.0/authorize?${params.toString()}`);
    })();
  }, []);
  return null;
}

/** Popup page that hands the result (a fresh access token, or the outcome of the admin-consent redirect) back to the tab. */
export function AuthEnd() {
  useEffect(() => {
    void (async () => {
      await app.initialize();
      const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
      const query = new URLSearchParams(window.location.search);
      const token = hash.get("access_token");
      const consent = query.get("consent");
      if (token) authentication.notifySuccess(token);
      else if (consent === "ok") authentication.notifySuccess("ok");
      else authentication.notifyFailure(hash.get("error") ?? consent ?? "failed");
      // when Microsoft's pages have cut the link with Teams (Cross-Origin-Opener-Policy) the result cannot be delivered: the
      // main page learns it from the API, and this window closes itself
      setTimeout(() => window.close(), 1500);
    })();
  }, []);
  return null;
}
